import React from 'react';
import { cn } from '@/lib/utils';

const Loading: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center p-20">
      <div className="w-full max-w-md space-y-8 text-center">
        {/* Main loading container with brand styling */}
        <div className="relative mb-8 flex flex-col items-center justify-center">
          {/* Animated dots */}
          <div className="flex gap-2">
            {[0, 1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className={cn(
                  'bg-muted-foreground h-3 w-3 rounded-full',
                  'animate-pulse opacity-100',
                )}
                style={{ animationDelay: `${i * 0.15}s` }}
              />
            ))}
          </div>
        </div>

        <p className="mt-8 hidden font-mono text-sm font-medium text-neutral-600 dark:text-neutral-400">
          Loading your experience...
        </p>
      </div>
    </div>
  );
};

export default Loading;
